export default class UI {
    static init() {
        UI.accordionWidget();
        UI.closeBanner();
        UI.dottedMenu();
    }

    private static accordionWidget() {
        const $accordion = $('.accordion');

        $accordion.each((index, el) => {
            const $el = $(el);

            if (
                $el.height() > $el.data('accordion-height') ||
                !$el.data('accordion-height')
            ) {
                $el.addClass('accordion-hidden');
                $el.find('.accordion__content').height(
                    $el.data('accordion-height')
                );
            }
            $el.find('.accordion__handle').text(
                $el.data('accordion-handle-hidden')
            );
        });

        $accordion.on('click', '.accordion__handle', (event) => {
            const $accordionHandle = $(event.target);
            const duration = 500;
            const accordionHeight = $accordionHandle
                .parent()
                .data('accordion-height');
            const accordionHandleTextOpened = $accordionHandle
                .parent()
                .data('accordion-handle-opened');
            const accordionHandleTextHidden = $accordionHandle
                .parent()
                .data('accordion-handle-hidden');
            const accordionContent = $accordionHandle
                .parent()
                .find('.accordion__content');

            const curHeight = accordionContent.height();
            const elementHeight = accordionContent
                .css('height', 'auto')
                .height();

            // Reset to Default Height
            accordionContent.height(curHeight);

            $accordionHandle.toggleClass('opened');
            accordionContent.toggleClass('opened');

            if ($accordionHandle.hasClass('opened')) {
                $accordionHandle.text(accordionHandleTextOpened);
                accordionContent
                    .stop()
                    .animate({ height: elementHeight }, duration, 'linear');
            } else {
                $accordionHandle.text(accordionHandleTextHidden);
                accordionContent
                    .stop()
                    .animate({ height: accordionHeight }, duration, 'linear');
            }
        });
    }

    private static closeBanner() {
        $('.banner.item').each((index, el) => {
            const bannerId = `banner_${$(el).data('banner-id')}`;

            if ($.cookie(bannerId) == 'closed') {
                $(el).remove();
            }
        });
        $('.banner').on('click', '.banner__close-button', (event) => {
            const $closeButton = $(event.currentTarget);
            const bannerId = `banner_${$closeButton.data('banner-id')}`;

            $.cookie(bannerId, 'closed', { expires: 1, path: '/' });
            $closeButton.parent().remove();
        });
    }

    static dottedMenu() {
        $("[data-ui-widget-dottedMenu='container']").each(function (index, element) {
            const $containerWidth = $(element).outerWidth(true);
            const $underCutWrapper = $(element).find("[data-ui-widget-dottedMenu='underCutWrapper']");
            const $underCutContainer = $(element).find("[data-ui-widget-dottedMenu='underCutContainer']");
            const $underCutContainerItems = $($underCutContainer).children("[data-ui-widget-dottedMenu='item']");
            const $containerItems = $(element).children("[data-ui-widget-dottedMenu='item']");
            var itemsWidth = $underCutWrapper.outerWidth(true);

            $containerItems.each(function (index, element) {
                itemsWidth += $(element).outerWidth(true);
            });

            if (itemsWidth > $containerWidth) {
                while (itemsWidth > $containerWidth) {
                    itemsWidth -= $containerItems.last().outerWidth(true);
                    $underCutContainer.prepend($containerItems.last());
                }
                $underCutWrapper.removeClass('hidden')
            } else {
                for (var i = 0; i <= $underCutContainerItems.length; i++) {
                    if (itemsWidth + $underCutContainerItems.last().width() < $containerWidth) {
                        $containerItems.last().after($underCutContainerItems.first());
                        itemsWidth += $underCutContainerItems.first().width();
                    } else {
                        break;
                    }

                }
            }

            if ($($underCutContainer).children("[data-ui-widget-dottedMenu='item']").length == 0) {
                $underCutWrapper.addClass('hidden')
            }
        });
    };
}
